import React from 'react';

import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useForm } from '../../../../shared/hooks/form-hook';
import Input from '../../../../shared/components/FormElements/input';
import { VALIDATOR_REQUIRE } from '../../../../shared/util/validators';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import ImageUpload from '../../../../shared/components/FormElements/imageUpload';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import './AddMend.css'


const AddMend = () => {

  const history = useHistory();

    const [formState, inputHandler  ] = useForm(
        {
            name: {
              value: '',
              isValid: false
            },
            title: {
              value: '',
              isValid: false
            },
            article: {
              value: '',
              isValid: false
            },
            image: {
                value: null,
                isValid: false
            },
            
            createdAt: {
              value: '',
              isValid: false
            }
        },
        false
    );

 
   

    const addHandler = async (event) => {
        event.preventDefault();

        try {
          const formData = new FormData();
          formData.append('name', formState.inputs.name.value);
          formData.append('title', formState.inputs.title.value);
          formData.append('article', formState.inputs.article.value);
          formData.append('image', formState.inputs.image.value);
         

          const response = await fetch(process.env.REACT_APP_BACKEND_URL + '/mend', {
            method: 'POST',
            body: formData
          });
         
        
        // try{
        //   const response = await fetch(${process.env.REACT_APP_BACKEND_URL}'/news', {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json'
        //   },
        //   body: JSON.stringify({
        //     title: formState.inputs.title.value,
        //     content: formState.inputs.content.value,
        //     image: formState.inputs.image.value,
        //     url: formState.inputs.url.value,
        //     createdAt: formState.inputs.createdAt.value
        //   })
        // });
        const responseData = await response.json();
        console.log(responseData)
          history.push('/');
        } catch (err) {
          console.log(err)
        }
        // window.success('Successfully');
    }

    return (  
        <main className='news-container'> 
          <Link to='/'><FontAwesomeIcon icon={faArrowLeft} className='font-controller-announce'/></Link>
            <h1>Шинэ айлдвар нэмэх</h1>  
          
            <div className='news-form-container'> 
            
            <form onSubmit={addHandler} className='news-form'>
                <Input 
                  element="input" 
                  id="name" 
                  type="text" 
                  label="Айлдвар айлдагчийн нэр"
                  autoComplete='off' 
                  validators={[VALIDATOR_REQUIRE()]}
                  errorText='Please enter a valid character' 
                  onInput={inputHandler}
                />
                <Input 
                  element="input" 
                  id="title" 
                  type="text" 
                  label="Гарчиг"
                  autoComplete='off' 
                  validators={[VALIDATOR_REQUIRE()]}
                  errorText='Please enter a valid character' 
                  onInput={inputHandler}
                />
                <Input 
                  element="textarea"
                  id="article" 
                  type="text" 
                  label="Айлдвар"
                  autoComplete='off' 
                  validators={[VALIDATOR_REQUIRE()]}
                  errorText='Please enter a your article' 
                  onInput={inputHandler}
                />
                
                <ImageUpload 
                  id='image'
                  onInput={inputHandler}
                />

                <Button type="submit" disabled={!formState.isValid} variant='contained' style={{marginTop: '20px'}}>Publish</Button>
            </form>
            </div> 
        </main>  
    )
}

export default AddMend;